import * as t from "./actionTypes";

/*
 * Add or update a shape in state
 */
export const createOrUpdateShape = (shapeType, shapeData) => {
	return {
		type: t.CREATE_UPDATE_SHAPE,
		payload: { shapeType, shapeData }
	};
};

/*
 * clear all shapes in state
 */
export const clearShapes = () => {
	return {
		type: t.REMOVE_ALL_SHAPES
	};
};

export const selectShape = (shapeType) => {
	return {
		type: t.SELECT_SHAPE,
		payload: { shapeType }
	};
};

export const selectShapeFeedId = (feedId) => {
	return {
		type: t.SELECT_SHAPE_FEED_ID,
		payload: { feedId }
	};
};
